<template>
  <v-container class="pa-0">

    <!-- If: Loading --->
    <template v-if="isLoading" >
      <v-alert light class="py-0 elevation-3" dense>
        <v-list dense class="py-0">
          <v-list-item dense class="pa-0">
            <v-list-item-avatar small>
              <span class="custom-loader">
                <v-icon large color="grey">cached</v-icon>
              </span>
            </v-list-item-avatar>
            <v-list-item-content>
              <span class="grey--text pr-10">Loading customers...</span>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-alert>
    </template>

    <!-- Else: Show Dropdown --->
    <template v-else>
      <v-toolbar flat light class="mt-n1 pa-y pr-2">

          <!-- Dropdopwn -->
          <v-select
            light      
            :value="value"                          
            :items="customers"
            :disabled="isLoading"
            :dense="isSmallDevice"
            hide-details
            solo
            @input="e => $emit('input', e)"
            @change="$emit('change')"
            class="ml-n4 mr-2 mt-1"
            >
            <template v-slot:selection="{ item }">
              <v-list dense class="py-0 pl-2">
                <v-list-item class="pa-0">
                  <v-list-item-avatar>
                    <v-img :src="item.picture"></v-img>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <span class="subtitle-1 font-weight-regular">
                      {{ item.text }}
                    </span>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </template>
          </v-select>

          <!-- Info Popup -->
          <v-menu top offset-y>
            <template v-slot:activator="{ on }">
              <v-btn icon color="primary" v-on="on" class="mr-n4 elevation-2" :disabled="!enableInfoButton">
                <v-icon color="primary">info</v-icon>
              </v-btn>
            </template>
            <v-card max-width="300px">

              <!-- Phones -->
              <v-list dense class="py-1">
                <v-list-item v-if="showPhone1">
                  <v-list-item-icon>
                    <v-icon small class="mr-2">phone</v-icon>
                    <span class="body-2 font-weight-medium mt-1">Phone 1</span>
                  </v-list-item-icon>
                  <v-list-item-content class="body-2 mt-1">
                    {{ selectedCustomerInfo.phone1 }}
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="showPhone2">
                  <v-list-item-icon>
                    <v-icon small class="mr-2">phone</v-icon>
                    <span class="body-2 font-weight-medium mt-1">Phone 2</span>
                  </v-list-item-icon>
                  <v-list-item-content class="body-2">
                    {{ selectedCustomerInfo.phone2 }}
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <!-- Preferences -->
              <template v-if="showBullPreferences">
                <v-divider v-if="showPhone1 || showPhone2"/>

                <v-card-subtitle class="body-1 font-weight-medium pb-0">
                  Preferences
                </v-card-subtitle>

                <v-card-text style="white-space: pre-line" class="pt-0 mt-n3">
                  {{ selectedCustomerInfo.bullPreferences }}
                </v-card-text>
              </template>
            </v-card>
          </v-menu>
      </v-toolbar>
    </template>
  </v-container>
</template>

<script>
import appService from '@/app.service'
import { AppColor } from '@/config.js'

export default {
  name: "BbCustomerDropdown",
  props: {
    value: {
      type: String,
      default: null
    },
    profile: {
      type: Object,
      default: null
    },
    withQueryOnly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      appColor_Light: AppColor.Light,
      isLoading: true,
      customers: []
    }
  },
  computed: {
    isBreeder () {
      return this.profile.roles !== null && this.profile.roles.includes('Breeder')
    },
    isSmallDevice () {
      return this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm'
    },
    showPhone1 () {
      const info = this.selectedCustomerInfo
      if (info == null) return false
      return info.phone1.length > 0
    },
    showPhone2 () {
      const info = this.selectedCustomerInfo
      if (info == null) return false

      const isPhone2 = info.phone2.length > 0
      const phonesMatch = this.showPhone1 && isPhone2
        ? info.phone1 === info.phone2
        : false

      return isPhone2 & !phonesMatch
    },
    showBullPreferences () {
      const info = this.selectedCustomerInfo
      if (info == null) return false
      return info.bullPreferences.length > 0
    },
    enableInfoButton () {
      const info = this.selectedCustomerInfo
      if (info == null) return false
      return info.phone1.length > 0
        || info.phone2.length > 0
        || info.bullPreferences.length > 0
    },
    selectedCustomerInfo () {
      //const id = this.customerId
      const id = this.value
      const customers = this.customers.filter(c => { return c.value === id })
      return customers.length > 0
          ? { 
              phone1: !this.isNullOrUndefined(customers[0].phone1) 
                ? customers[0].phone1 : '',
              phone2: !this.isNullOrUndefined(customers[0].phone2) 
                ? customers[0].phone2 : '',
              bullPreferences: !this.isNullOrUndefined(customers[0].bullPreferences)
                ? customers[0].bullPreferences : ''
            }
          : null
    }
  },
  methods: {
    loadData () {
      const self = this
      appService.getBullFinderCustomers(self.withQueryOnly).then(data => {
        if (data.errorSeverity !== null) {
          self.$emit('error', { error: {
            severity: data.errorSeverity,
            message: data.errorMessage
          }})
        } else {
          const customers = self.buildArray(data.users)
          self.customers = customers
          self.$emit('load', { customers })
        }
        self.isLoading = false
      }).catch(() => { self.isLoading = false })
    },

    buildArray (userCustomers) {
      const self = this
      var customers = []

      customers = userCustomers.map(c => {
        return {
          value: c.id,
          text: c.contactName,
          contactName: c.contactName,
          name: c.name,
          phone1: c.phone1,
          phone2: c.phone2,
          picture: c.picture,
          bullPreferences: c.bullPreferences,
          accountNo: c.accountNo,
          isBreeder: c.isBreeder
        }
      })

      // current user model (derive from vuex profile)
      const currentUser = {
        value: self.profile.id,
        text: self.profile.name,
        contactName: self.profile.bbCustomerStatus.contactName,
        name: self.profile.name,
        phone1: self.profile.phone1,
        phone2: self.profile.phone2,
        picture: self.profile.picture,
        bullPreferences: self.profile.bullPreferences,
        accountNo: self.profile.bbCustomerStatus.accountNo,
        isBreeder: self.isBreeder,
      }

      // remove it if it's already in the list
      const userCusts = customers.filter(c => { return c.value === currentUser.value })
      if (userCusts.length > 0) {
        const idx = customers.indexOf(userCusts[0])
        customers.splice(idx, 1)
      }

      // re-add it to the top
      customers.unshift(currentUser)

      return customers
    },

    isNullOrUndefined (obj) {
      return obj === undefined 
        || typeof obj === 'undefined' 
        || obj === null
    }
  },
  created () {
    this.loadData()
  }
}
</script>